import { GraphQLError } from 'graphql';

const CODE_REAUTHENTICATION_REQUIRED = 'reauthentication-required';

export const isFetchResponseUnauthenticated = async (resp: Response): Promise<boolean> => {
  return resp.status === 401;
};

export const isFetchResponseUnauthorized = async (resp: Response): Promise<boolean> => {
  return resp.status === 403;
};

export const isFetchResponseReauthRequired = async (resp: Response): Promise<boolean> => {
  if (resp.status !== 403) {
    return false;
  }

  try {
    const json = await resp.json();
    return json?.metadata?.code === CODE_REAUTHENTICATION_REQUIRED || false;
  } catch {
    return false;
  }
};

export const isGraphQLErrorUnauthenticated = (error: GraphQLError): boolean => {
  // TODO: Update Athena error serialization so we don't need to look at the stacktrace.
  // https://opendoor.atlassian.net/browse/SXP-587
  return error.message.startsWith('HTTP Error 401');
};

export const isGraphQLErrorUnauthorized = (error: GraphQLError): boolean => {
  // TODO: Update Athena error serialization so we don't need to look at the stacktrace.
  // https://opendoor.atlassian.net/browse/SXP-587
  return error.message.startsWith('HTTP Error 403');
};

export const isGraphQLErrorReauthRequired = (error: GraphQLError): boolean => {
  // TODO: Update Athena error serialization so we don't need to look at the stacktrace.
  // https://opendoor.atlassian.net/browse/SXP-587
  return (
    error.message.startsWith('HTTP Error 403') &&
    error.message.includes(`"code":"${CODE_REAUTHENTICATION_REQUIRED}"`)
  );
};
